export default interface TransactionItemDimension {
    id: number;
    head: number;
    dimCodeType: number;
    dimCode: number;
    total: number;
    project: number;
    poId: number;
    workNumber: string;
    userId: number;
    stationId: number;
    toolId: number;
    carId: number;
    parts: number;
    production: number;
    regNum: string;
    projectName: string;
    projectCode: string;
    userName: string;
    stationName: string;
    partsName: string;
    accGroup: number;
    accGroupName: string;
    toolName: string;
    extProdParts: number;
    extProdPartsCode: string;
    extProdPartsName: string;
    dimCodeName: string;
    stock: number;
    partsCode: string;
    projectMainCode: string;
    extProdPartner: number;
    extProdPartnerName: string;

    inEdit: boolean;
    selected: boolean;
    deleting: boolean;
}

export const TransactionItemDimensionDefaultProps: TransactionItemDimension = {
    id: 0,
    head: 0,
    dimCodeType: 0,
    dimCode: 1,
    total: 0,
    project: 1,
    poId: 1,
    workNumber: "",
    userId: 1,
    stationId: 1,
    toolId: 1,
    carId: 1,
    parts: 1,
    production: 1,
    regNum: "",
    projectName: "",
    projectCode: "",
    userName: "",
    stationName: "",
    partsName: "",
    accGroup: 0,
    accGroupName: "",
    toolName: "",
    extProdParts: 1,
    extProdPartsCode: "",
    extProdPartsName: "",
    dimCodeName: "",
    stock: 1,
    partsCode: "",
    projectMainCode: "",
    extProdPartner: 1,
    extProdPartnerName: "",

    inEdit: false,
    selected: false,
    deleting: false,
};